import { hasWindow } from '@obeta/utils/lib/ssr'

export const useRemToPx = (rem: number) => {
  if (!hasWindow()) {
    return 0
  }

  return parseInt(window.getComputedStyle(document.body).fontSize, 10) * rem
}
